import React, { useEffect, useState } from "react";
import "./CardSevenScreen.css";
import mixpanel from "../../mixpanel";
import StockTradingArm from "../../assets/stocktradingarm.jpg";
import MyInvest from "../../assets/myinvest.jpg";
import SmartFinance from "../../assets/smartFinanceBlog.jpg";
import AlbertGevorgyanBlog from "../../assets/albertGevorgyanBlog.jpg";
import eqwefy from "../../assets/eqwefy.jpg";
import veritas from "../../assets/veritas.jpg";
import financeAcademy from "../../assets/finance-academy.jpg";
import coopek from "../../assets/coopek.jpg";

const ecosystemPartners = [
  {
    img: MyInvest,
    title: "MyInvest-ի ներդրումային բլոգը",
    link: "https://t.me/myinvest_blog",
    event: "ecosystem_myinvest_clicked",
  },
  {
    img: AlbertGevorgyanBlog,
    title: "Ալբերտ Գևորգյանի կրիպտո թրեյդինգի բլոգը",
    link: "https://t.me/albertcryptotrading",
    event: "ecosystem_albert_crypto_clicked",
  },
  {
    img: StockTradingArm,
    title: "Լևոն Վարդանյանի ներդրումային բլոգը",
    link: "https://t.me/stocktradingarm",
    event: "ecosystem_stocktrading_clicked",
  },
  {
    img: SmartFinance,
    title: "Աննա Ասլիկյանի ֆինանսական գրագիտության բլոգը",
    link: "https://www.instagram.com/smart_finance___/",
    event: "ecosystem_smart_finance_clicked",
  },
  {
    img: veritas,
    title: "Veritas ներդրումային դասընթացներ",
    link: "https://www.instagram.com/veritas.finedu/",
    event: "ecosystem_veritas_clicked",
  },
  {
    img: financeAcademy,
    title: "Finance Academy դասընթացներ",
    link: "https://www.instagram.com/financeacademy.am/",
    event: "ecosystem_finance_academy_clicked",
  },
  {
    img: eqwefy,
    title: "Ներդրումներ հայկական ստարտափներում",
    link: "https://eqwefy.com/en",
    event: "ecosystem_eqwefy_clicked",
  },
  {
    img: coopek,
    title: "Ալիք ֆինանսական գրագիտության մասին",
    link: "https://www.instagram.com/coopek.fin/",
    event: "ecosystem_coopek_clicked",
  },
];

export default function CardSevenScreen() {
  const [cardsVisible, setCardsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setCardsVisible(true);
          }
        });
      },
      { threshold: 0.3 }
    );

    const element = document.querySelector('.card-seven-screen');
    if (element) {
      observer.observe(element);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <div className="card-seven-screen">
      <div className="card-seven-content">
        <h1 className="card-seven-title">Մեր էկոսիստեմում</h1>
        <div className="ecosystem-grid">
          {ecosystemPartners.map((partner, index) => (
            <a
              key={index}
              href={partner.link}
              target="_blank"
              rel="noopener noreferrer"
              className={`ecosystem-card ${cardsVisible ? 'fade-in' : ''}`}
              style={{ transitionDelay: `${index * 0.1}s` }}
              onClick={() => mixpanel.track(partner.event)}
            >
              <div className="ecosystem-icon">
                <img src={partner.img} alt={partner.title} />
              </div>
              <h3 className="ecosystem-title">{partner.title}</h3>
            </a>
          ))}
        </div>
      </div>
    </div>
  );
}
